import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { buttonClass, EmptyState, ErrorState } from '@/core/ui';
import type { RouterContext } from '@/app/router';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  // Erro inesperado numa tela não pode virar página em branco.
  errorComponent: ({ error, reset }) => (
    <div className="flex min-h-[50vh] items-center justify-center p-6">
      <ErrorState error={error} onRetry={reset} className="w-full max-w-md" />
    </div>
  ),
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-6">
      <EmptyState
        title="Página não encontrada"
        description="O endereço pode estar errado ou a página foi removida."
        action={
          <Link to="/" className={buttonClass()}>
            Ir para o painel
          </Link>
        }
      />
    </div>
  ),
});
